import { useQuery } from "react-query";
import FeaturesDataService from "../../services/features-data-service/FeaturesDataService";
import { FeatureConstants } from "../../services/features-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseEvaluateFeatureParameters<T=unknown> = {
    feature: FeatureConstants
} & BaseUseQueryParameters<T>;

export function useEvaluateFeature<T=unknown>({
    feature,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseEvaluateFeatureParameters<T>): ReturnType<typeof useQuery<T, RestError>> {
    return useQuery<T, RestError>(
        keys.list([feature]),
        ({ signal }) => {
            return FeaturesDataService.evaluateFeature<T>(feature, signal);
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false
        }
    );
}